export default "__VITE_ASSET__Bv0gvcPA__"